import { render, staticRenderFns } from "./base.vue?vue&type=template&id=37ef7fbc&scoped=true&"
import script from "./base.vue?vue&type=script&lang=js&"
export * from "./base.vue?vue&type=script&lang=js&"
import style0 from "./base.vue?vue&type=style&index=0&id=37ef7fbc&prod&lang=scss&"
import style1 from "./base.vue?vue&type=style&index=1&id=37ef7fbc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ef7fbc",
  null
  
)

export default component.exports